import { create } from 'zustand'

interface GlobalProgressState {
  isActive: boolean
  message?: string
  progress?: number
  setGlobalProgress: (state: {
    isActive: boolean
    message?: string
    progress?: number
  }) => void
  reset: () => void
}

export const useGlobalProgressStore = create<GlobalProgressState>((set) => ({
  isActive: false,
  message: '',
  progress: 0,
  setGlobalProgress: (state) => set(state),
  reset: () => set({ isActive: false, message: '', progress: 0 }),
}))